<div *ngIf="!mostrarFormulario" class="row animated fadeInRight">

  <app-lfsa-card-v2 *ngIf="mostrarGridLista && mostrarGridLista==='ListaPedidos'"
                    [innTemplateButton]="innTemplateButtonPedidos"
                    [innTemplate]="enviarTemplatePedidos" [modulo]="DAT_TITULOS.modulo" [tituloCard]="titulo"
                    [titulo]="DAT_TITULOS.titulo">
  </app-lfsa-card-v2>
  <ng-template #innTemplateButtonPedidos>
  </ng-template>
  <ng-template #enviarTemplatePedidos>
    <app-lfsa-botones-formulario (devolverAccion)="acciones( $event )"
                                 [loading]="loading"
                                 [mostrarBotonVerde]="false">
    </app-lfsa-botones-formulario>
    <div class="row">
      <div class="col-md-12 ">
        <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
        <ag-grid-angular #agGrid (gridReady)="onGridReadyPedidos($event)" [columnDefs]="columnDefsPedidos"
                         [floatingFilter]="true" [frameworkComponents]="frameworkComponentsPedidos"
                         [ngStyle]="diccionarioModulo.agGrid.style"
                         [paginationPageSize]="diccionarioModulo.agGrid.paginacion"
                         [pagination]="true" [rowData]="rowDataPedidos"
                         [rowSelection]="rowSelectionPedidos" class="{{diccionarioModulo.agGrid.class}}"
                         id="{{diccionarioModulo.agGrid.idPedidos}}">
        </ag-grid-angular>
      </div>
    </div>
  </ng-template>

  <app-lfsa-card-v2 *ngIf="mostrarGridLista && mostrarGridLista==='ListaExtractos'"
                    [innTemplateButton]="innTemplateButton"
                    [innTemplate]="enviarTemplateEdit" [modulo]="DAT_TITULOS.modulo" [tituloCard]="titulo"
                    [titulo]="DAT_TITULOS.titulo">
  </app-lfsa-card-v2>
  <ng-template #innTemplateButton>
  </ng-template>
  <ng-template #enviarTemplateEdit>
    <form [formGroup]="formularioExtractos" class="form-group" novalidate>
      <div class="row">
        <div class="col-md-12 mb-4">
          <div class="form-group col-md-2">
            <app-lfsa-combo-box (change)="getExtractos(rowSelected)" [comboBox]="cmbEan14"
                                [control]="this.formularioExtractos.get('idBanco') | formControl" [idOpcion]="'idBanco'"
                                [id]="'idBanco'"
                                [label]="'Banco'" [opcion]="'dscaBanco'"
                                formControlName="idBanco"></app-lfsa-combo-box>
          </div>
        </div>
      </div>
    </form>
    <app-lfsa-botones-formulario (devolverAccion)="acciones( $event )"
                                 [formularioValido]="validateForm()"
                                 [loading]="loading"
                                 [textBoton]="textBoton"
    >
    </app-lfsa-botones-formulario>
    <div class="row">
      <div class="col-md-12 ">
        <!--        <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>-->
        <ag-grid-angular #agGrid (gridReady)="onGridReadyExtractos($event)" [columnDefs]="columnDefsExtractos"
                         [floatingFilter]="true" [frameworkComponents]="frameworkComponentsExtractos"
                         [ngStyle]="diccionarioModulo.agGrid.style"
                         [paginationPageSize]="diccionarioModulo.agGrid.paginacion" [pagination]="true"
                         [rowData]="rowDataExtractos"
                         [rowSelection]="rowSelectionExtractos"
                         [suppressRowClickSelection]="true" class="{{diccionarioModulo.agGrid.class}}"
                         id="{{diccionarioModulo.agGrid.idExtractos}}">
        </ag-grid-angular>
      </div>
    </div>
  </ng-template>
  <!-- *GRID LISTAR ROL -->
  <app-lfsa-card-v2 *ngIf="mostrarGridLista && mostrarGridLista ==='ListaCobros'"
                    [innTemplate]="enviarTemplate" [modulo]="'Perform Capturadora'" [tituloCard]="titulo"
                    [titulo]="DAT_TITULOS.titulo">
  </app-lfsa-card-v2>
  <ng-template #enviarTemplate>
    <section class="section">
      <form [formGroup]="formulario" class="form-group" novalidate>
        <div class="row mb-4">
          <div class="form-group col-12 col-md-2">
            <app-lfsa-combo-box (change)="getLineaPlanta()" [mostrarImg]="false" [rutaImagen]="''"
              [opcion]="'nombre'" [idOpcion]="'id'" [comboBox]="cmbPlanta" formControlName="planta"
              [control]="formulario.get('planta')" [label]="'Planta'" [id]="'planta'">
            </app-lfsa-combo-box>
          </div>
          <div class="form-group col-12 col-md-2">
            <app-lfsa-combo-box [mostrarImg]="false" [rutaImagen]="''"
              [opcion]="'nombre'" [idOpcion]="'id'" [comboBox]="cmbLinea" formControlName="linea"
              [control]="formulario.get('linea')" [label]="'Línea'" [id]="'linea'">
            </app-lfsa-combo-box>
          </div>
          <div class="form-group col-md-2">
            <app-lfsa-input [control]="formulario.get('fechaIni') | formControl"
                            (change)='obtainDate()'
                            [id]="'fechaIni'"
                            [label]="'Fecha Inicio*'" [mostrarImg]="false" [placeholder]="'Fecha'"
                            [rutaImagen]=""
                            [type]="'date'"
                            formControlName="fechaIni">
            </app-lfsa-input>
          </div>
          <div class="form-group col-md-2">
            <app-lfsa-input [control]="formulario.get('fechaFin') | formControl"
                            (change)='obtainDate()'
                            [id]="'fechaFin'"
                            [label]="'Fecha Fin*'" [mostrarImg]="false" [placeholder]="'Fecha'"
                            [rutaImagen]=""
                            [type]="'date'"
                            formControlName="fechaFin">
            </app-lfsa-input>
          </div>
          <!--<div class="form-group col-md-8">
            <app-lfsa-combo-box [comboBox]="cmbEan14"
                                (change)='obtainLote()'
                                [control]="this.formulario.get('ean14') | formControl" [idOpcion]="'clave'"
                                [id]="'ean14'"
                                [label]="'Material - Ean14'" [opcion]="'valor'"
                                formControlName="ean14"></app-lfsa-combo-box>
          </div>-->
          <div class="col-md-4 animated fadeInRight">
            <app-lfsa-combo-box-v3 *ngIf="comboView" [innerValue]="formulario.get('ean14').value"
                                        [mostrarImg]="false"
                                        formControlName="ean14"
                                       [control]="formulario.get('ean14')" 
                                       [opcion]="'valor'" [idOpcion]="'clave'" [comboBox]="cmbEan14"
                                       [label]="'Material - EAN14'" [id]="'ean14'">
                </app-lfsa-combo-box-v3>
          </div>

          
          <!--<div class="form-group col-md-2">
            <app-lfsa-combo-box [comboBox]="cmbLote"
                                [control]="this.formulario.get('lote') | formControl" [idOpcion]="'clave'"
                                [id]="'lote'"
                                [label]="'Lote'" [opcion]="'valor'"
                                formControlName="lote"></app-lfsa-combo-box>
          </div>
          <div class="form-group col-md-2">
            <app-lfsa-combo-box [comboBox]="cmbEstado"
                                [control]="this.formulario.get('estado') | formControl" [idOpcion]="'clave'"
                                [id]="'estado'"
                                [label]="'Estado'" [opcion]="'valor'"
                                formControlName="estado"></app-lfsa-combo-box>
          </div>-->

        </div>
        <div class="row mb-4">
          <div class="form-group col-md-10">
            <button (click)="generarReport()"
            [disabled]="formulario.invalid"
            class="{{DAT_BTNCSS.primary}}">{{ DAT_BTNS.buscar }}
            </button>
          </div>
          <div class="form-group col-md-2">
            <button [disabled]="!mostrarTabla" *ngIf="!loading" class="btn btn-success btn-block"  (click)="exportCSV()" >
              <i class="fa fa-download" aria-hidden="true"></i></button>
          </div>
        </div>
      </form>
      <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
      <div *ngIf="mostrarTabla" class="row">
        <div class="col-md-12 ">
          <ag-grid-angular #agGrid (gridReady)="onGridReady($event)" [columnDefs]="columnDefs"
                           [floatingFilter]="true" [frameworkComponents]="frameworkComponents"
                           [ngStyle]="diccionarioModulo.agGrid.style"
                           [paginationPageSize]="diccionarioModulo.agGrid.paginacion"
                           [pagination]="true" [rowData]="rowData"
                           [rowSelection]="rowSelection" class="{{diccionarioModulo.agGrid.class}}"
                           id="{{diccionarioModulo.agGrid.id}}">
          </ag-grid-angular>
        </div>
      </div>
    </section>
  </ng-template>
</div>
